import { BranchMappingDetailPage } from "@/features/branch-sales-channel/pages/BranchMappingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-sales-channel/$id/detail")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["masterdata.lookup"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchMappingDetailPage,
});
